import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectsSelectFieldPlaceholder: {
		id: 'polaris-component-collection-create.form.project-select.projects-select-field-placeholder',
		defaultMessage: 'Select projects',
		description: 'Placeholder for projects select field',
	},
});
